export enum PricingModeKey {
    GrossValue = 'grossValue',
    NetValue = 'netValue',
    Value = 'value',
}
